import { render, staticRenderFns } from "./ComicForm.vue?vue&type=template&id=dfc02eb6&"
import script from "./ComicForm.vue?vue&type=script&lang=js&"
export * from "./ComicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports